import React from 'react'; // Rebuild trigger
import ReactDOM from "react-dom/client";
import App from "./app/App.tsx";
import "./styles/globals.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
